/* app/js/src/components/destinations/destination-settings/destination-platform-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.destination-settings-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 0 0.5rem 2.25rem;
}
.destination-settings-form__readonly-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.destination-settings-form__readonly-row .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destination-settings-form__readonly-row .value {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.54);
}
.destination-settings-form__dropdown-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem 2rem;
  width: 100% !important;
  max-width: 100%;
}
.destination-settings-form__dropdown-row .ts-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  flex: 0 1 auto;
}
.destination-settings-form__dropdown-row .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  width: auto;
}
.destination-settings-form__dropdown-row .ts-action icn-dropdown {
  width: 14rem;
  min-width: 10rem;
}
.destination-settings-form__checkbox-row {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100% !important;
}
.destination-settings-form__checkbox-row .ts-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.destination-settings-form__checkbox-row .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destination-settings-form__instagram {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}
.destination-settings-form__facebook {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}
.destination-settings-form__facebook .destination-settings-form__dropdown-row .ts-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  flex: 0 1 auto;
}
.destination-settings-form__facebook .destination-settings-form__dropdown-row .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  width: auto;
}
.destination-settings-form__facebook .destination-settings-form__dropdown-row .ts-action icn-dropdown {
  width: 14rem;
  min-width: 10rem;
}
.destination-settings-form__facebook-dropdown-label {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
}
.destination-settings-form__facebook-checkbox {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.destination-settings-form__facebook-checkbox .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destination-settings-form__field-help {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  flex: 0 0 1rem;
  border: 1px solid rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  color: rgba(0, 0, 0, 0.54);
  font-family: "Open Sans", sans-serif;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  outline: none;
}
.destination-settings-form__field-help:hover .destination-settings-form__field-tooltip,
.destination-settings-form__field-help:focus .destination-settings-form__field-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -0.25rem);
}
.destination-settings-form__field-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.5rem);
  z-index: 10;
  width: 16rem;
  max-width: 70vw;
  padding: 0.625rem 0.75rem;
  border-radius: 0.375rem;
  background-color: #232f3a;
  color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: left;
  white-space: normal;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, 0);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    visibility 0.2s ease;
  pointer-events: none;
}
.destination-settings-form__facebook-dropdown-field--category ::ng-deep icn-dropdown ul {
  max-height: 9.5rem;
  overflow-y: auto;
}
.destination-settings-form__empty {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.54);
}
.destination-settings-form .ts-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.destination-settings-form .ts-action .label {
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.destination-settings-form--readonly .destination-settings-form__checkbox-row .ts-action,
.destination-settings-form--readonly .destination-settings-form__dropdown-row .ts-action,
.destination-settings-form--readonly .destination-settings-form__facebook-checkbox {
  opacity: 0.85;
}
.destination-settings-form--clipping-sidebar {
  gap: 6px;
}
.destination-settings-form--clipping-sidebar .ts-action {
  gap: 8px;
}
.destination-settings-form--clipping-sidebar .ts-action .label {
  font-size: 12px;
  font-weight: 400;
}
.destination-settings-form--clipping-sidebar .destination-settings-form__facebook {
  gap: 6px;
}
.destination-settings-form--clipping-sidebar .destination-settings-form__facebook-checkbox .label,
.destination-settings-form--clipping-sidebar .destination-settings-form__facebook .destination-settings-form__dropdown-row .label,
.destination-settings-form--clipping-sidebar .destination-settings-form__facebook-dropdown-label .label {
  font-size: 12px;
  font-weight: 400;
}
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-checkbox {
  --mdc-checkbox-selected-checkmark-color: rgb(255, 255, 255);
  --mdc-checkbox-selected-focus-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-hover-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-icon-color: rgb(45, 187, 252);
  --mdc-checkbox-selected-pressed-icon-color: rgb(45, 187, 252);
}
.destination-settings-form--clipping-sidebar ::ng-deep .mdc-checkbox__ripple,
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-checkbox-ripple,
.destination-settings-form--clipping-sidebar ::ng-deep .mat-mdc-focus-indicator {
  display: none;
}
/*# sourceMappingURL=destination-platform-settings.component.css.map */
